var checksOK=null;
var extCakePokerBonus = "9";

var isEmailVerifiedJSON = {

    checkIsMobileVerified: false,
    checkIsEmailVerified: false,

    success: function(o){

        var params = YAHOO.lang.JSON.parse(o.responseText);

        var checkIsMobileVerified = isEmailVerifiedJSON.checkIsMobileVerified;
        var checkIsEmailVerified = isEmailVerifiedJSON.checkIsEmailVerified;

        if(params.RESULT == "OK"){
            isEmailVerified=true;
            if (!isMobileVerified && checkIsMobileVerified){
                checkMobileVerification(checkIsEmailVerified);
            } else {
                checksOK.execute();
            }
            return false;
        } else{
            if (!isMobileVerified && checkIsMobileVerified){
                checkMobileVerification(checkIsEmailVerified);
            } else {
                // Show email must be verified popup
                window.top.showEmailMobileVerificationError(textHeaderVerifyEmail, textBodyVerifyEmail, textVerifyEmailMobileLink, textBtnVerifyEmailMobileLater, true, null, null, textPanelHeaderVerifyEmail);
            }
            return false;
        }
    },
    failure: function(o) {
        // Is not allowed to go wrong
        return false;
    },
    cache: false,
    timeout: 10000
};

var isMobileVerifiedJSON = {

        checkIsEmailVerified: false,

        success: function(o){

            var params = YAHOO.lang.JSON.parse(o.responseText);

            var checkIsEmailVerified = isEmailVerifiedJSON.checkIsEmailVerified;

            if(params.RESULT == "OK"){
                //
                if (!isEmailVerified && checkIsEmailVerified){
                    // Show email must be verified popup
                    window.top.showEmailMobileVerificationError(textHeaderVerifyEmail, textBodyVerifyEmail, textVerifyEmailMobileLink, textBtnVerifyEmailMobileLater, true, null, null, textPanelHeaderVerifyEmail);
                } else {
                    checksOK.execute();
                }
                return false;
            } else{
                if (!isEmailVerified && checkIsEmailVerified){
                    // Show email and mobile must be verified popup
                    window.top.showEmailMobileVerificationError(textHeaderVerifyEmailMobile, textBodyVerifyEmailMobile, textVerifyEmailMobileLink, textBtnVerifyEmailMobileLater, true, null, null, textPanelHeaderVerifyEmailMobile);
                } else {
                    // Show mobile must be verified popup
                    window.top.showEmailMobileVerificationError(textHeaderVerifyMobile, textBodyVerifyMobile, textVerifyEmailMobileLink, textBtnVerifyEmailMobileLater, true, null, null, textPanelHeaderVerifyMobile);
                }
                return false;
            }
        },
        failure: function(o) {
            // Is not allowed to go wrong
            return false;
        },
        cache: false,
        timeout: 10000
};

function bonusChecks(inContinue, bonusTypeId) {

    var checkIsEmailVerified;
    var checkIsMobileVerified;


	if (window.freeMoneyBonusTypeIds.conditional === bonusTypeId) {
		checkIsEmailVerified = checkIsEmailVerifiedFreeMoneyBonus;
		checkIsMobileVerified = checkIsMobileVerifiedFreeMoneyBonus;
	} else {
		checkIsEmailVerified = checkIsEmailVerifiedDepositBonus;
		checkIsMobileVerified = checkIsMobileVerifiedDepositBonus;
	}

	checksOK = inContinue;
	if (window.freeMoneyBonusTypeIds.instant === bonusTypeId) {
		checksOK.execute();
	} else if(bonusTypeId === extCakePokerBonus) {
		checksOK.execute();
	} else if (!isEmailVerified && checkIsEmailVerified) {
		checkEmailVerification(checkIsMobileVerified, checkIsEmailVerified);
	} else if (!isMobileVerified && checkIsMobileVerified) {
		checkMobileVerification(checkIsEmailVerified);
	} else {
		checksOK.execute();
	}
    return false;
}

function checkEmailVerification(checkIsMobileVerified, checkIsEmailVerified){

    isEmailVerifiedJSON.checkIsMobileVerified = checkIsMobileVerified;
    isEmailVerifiedJSON.checkIsEmailVerified = checkIsEmailVerified;

    YAHOO.util.Connect.asyncRequest('POST',
            '/pp',
            isEmailVerifiedJSON,
            'flow=IsEmailVerified');

}

function checkMobileVerification(checkIsEmailVerified){

    isMobileVerifiedJSON.checkIsEmailVerified = checkIsEmailVerified;

    YAHOO.util.Connect.asyncRequest('POST',
            '/pp',
        isMobileVerifiedJSON,
        'flow=IsMobileVerified');
}
;
define("legacy/bonus/bonusChecks", function(){});

